import { Injectable, Inject, Optional } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { Observable } from "rxjs/Observable";
import { of } from "rxjs/observable/of";
import { _throw } from "rxjs/observable/throw";
import { catchError, map, tap, delay } from "rxjs/operators";

import { CommonService } from "./common.service";

import { User } from "./users.model";
import { MessageService } from "./message.service";

import { environment } from "../../environments/environment";

export class SigninInfo {
  m_user_id: string;
  role_id: number;
  user_name: string;
  account: string;
  contract_company_id: number;
  contract_company_name: string;
  contact_company_setting: any;
  customize_class: string | null;
}

@Injectable()
export class UsersService {
  constructor(
    private http: HttpClient,
    private commonService: CommonService,
    private messageService: MessageService,
  ) {}

  users: User[] = [];
  isSignin: boolean;
  private httpOptions = this.commonService.httpOptions;
  private Options = this.commonService.Options;

  userinfo: SigninInfo = {
    m_user_id: "",
    role_id: 0,
    user_name: "",
    account: "",
    contract_company_id: 0,
    contract_company_name: "",
    contact_company_setting: {
      password_change_flg: false,
      password_lock_count: 0,
      password_expire_days: 0,
      password_complexity_flg: false,
      monsin_contract_flg: false,
      yoyaku_contract_flg: false,
    },
    customize_class: null,
  };
  regUserInfo(ui: any) {
    this.userinfo = {
      m_user_id: ui.m_user_id,
      role_id: ui.role_id,
      user_name: ui.user_name,
      account: ui.account,
      contract_company_id: ui.contract_company_id,
      contract_company_name: ui.contract_company_name,
      contact_company_setting: {
        password_change_flg: this.commonService.exchange01toTF(
          ui.password_change_flg,
        ),
        password_lock_count: ui.password_lock_count,
        password_expire_days: ui.password_expire_days,
        password_complexity_flg: this.commonService.exchange01toTF(
          ui.password_complexity_flg,
        ),
        monsin_contract_flg: this.commonService.exchange01toTF(
          ui.monsin_contract_flg,
        ),
        yoyaku_contract_flg: this.commonService.exchange01toTF(
          ui.yoyaku_contract_flg,
        ),
      },
      customize_class: ui.customize_class,
    };
  }
  clearUserInfo() {
    this.userinfo = {
      m_user_id: "",
      role_id: 0,
      user_name: "",
      account: "",
      contract_company_id: 0,
      contract_company_name: "",
      contact_company_setting: {
        password_change_flg: false,
        password_lock_count: 0,
        password_expire_days: 0,
        password_complexity_flg: false,
        monsin_contract_flg: false,
        yoyaku_contract_flg: false,
      },
      customize_class: null,
    };
  }

  /** signin */
  signin(usermodel, kcode) {
    let param = {
      username: usermodel.username,
      password: usermodel.password,
      kcode: kcode,
    };
    return this.http
      .post(environment.apiUrl + "/api/user/login", param, this.Options)
      .pipe(
        delay(1000),
        tap((Response) => (this.isSignin = true)),
        // Do not turn an HTTP failure into a successful empty response.
        // The component's error callback must handle authentication failures.
        catchError((error) => _throw(error)),
      );
  }

  /** signout */
  signout() {
    return this.http.get<User[]>(environment.apiUrl + "/api/user/logout").pipe(
      tap((Response) => (this.isSignin = false)),
      catchError(this.commonService.handleError("signout", [])),
    );
  }

  checkSingin() {
    return this.http
      .get(environment.apiUrl + "/api/user/isloggedin", this.httpOptions)
      .pipe(
        tap((Response) => true),
        catchError(this.commonService.handleError("signin", [])),
      );
  }

  updatePassword(param): Observable<User[]> {
    this.commonService.loadingStart();
    return this.http
      .post<
        User[]
      >(environment.apiUrl + "/api/user/update", param, this.Options)
      .pipe(
        tap((Response) => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError("updatePassword", [])),
      );
  }
  resetPassword(param) {
    this.commonService.loadingStart();
    return this.http
      .post(environment.apiUrl + "/api/user/reset", param, this.Options)
      .pipe(
        tap((Response) => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError("resetPassword", [])),
      );
  }
  getContractInfo(param: any) {
    return this.http
      .get(
        environment.apiUrl + "/api/user/contract_info/" + param,
        this.httpOptions,
      )
      .pipe(
        tap((Response) => true),
        catchError(this.commonService.handleError("signin", [])),
      );
  }
  getServerConnection() {
    return this.http
      .get(environment.apiUrl + "/api/user/sso_info", this.httpOptions)
      .pipe(
        tap((Response) => true),
        catchError(this.commonService.handleError("server_connection", [])),
      );
  }
  delSsoSession() {
    return this.http
      .get(environment.apiUrl + "/api/user/sso_session_del", this.httpOptions)
      .pipe(
        tap((Response) => true),
        catchError(this.commonService.handleError("server_connection", [])),
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/service/users.service.ts